


import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import {
    getAllCampaignsAPI,
    getAllScreensAPI,
    updateCampaignApprovalAPI,
    deleteCampaignAPI,
    getCampaignByIdAPI,
    createCampaignAPI,
    updateCampaignStatusAPI
} from "../../../../Component/Servicefile/campaignService";
import { Calendar, ChevronDown } from "lucide-react";
import { FaPlay, FaPause, Faspinner } from 'react-icons/fa';
// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Users: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    CheckCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    XCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    Clock: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    Today: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <circle cx="12" cy="15" r="1" />
            <circle cx="16" cy="15" r="1" />
            <circle cx="8" cy="15" r="1" />
        </svg>
    ),
    Add: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    ),
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Delete: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
    ),
    View: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Campaign: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
        </svg>
    ),
    Image: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="2" width="20" height="20" rx="2" />
            <circle cx="8.5" cy="8.5" r="2.5" />
            <path d="M21 15l-5-5L5 21" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Approve: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#276749" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    Reject: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9b2c2c" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        // background: '#f8f9fa',
        borderRadius: '16px',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginBottom: '16px',
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #edf2f7'
    },
    statItem: {
        textAlign: 'center'
    },
    statValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    statLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        width: '80vw',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1600px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeApproved: {
        background: '#c6f6d5',
        color: '#276749'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    badgeRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    button: {
        padding: '6px 14px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '32px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 2px 10px rgba(230, 109, 51, 0.2)'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonInfo: {
        background: '#63b3ed',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    modal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '580px',
        maxWidth: '95%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px',
        // position: 'sticky',
        top: 0,
        background: 'white',
        zIndex: 5
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    modalBody: {
        padding: '0 0 4px 0'
    },
    formGroup: {
        marginBottom: '16px'
    },
    label: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    input: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white'
    },
    textarea: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit'
    },
    select: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white',
        cursor: 'pointer'
    },
    modalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px',
        // position: 'sticky',
        bottom: 0,
        background: 'white',
        zIndex: 5
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
        justifyContent: 'center',
        // flexWrap: 'wrap'
    },
    creativePreview: {
        width: '60px',
        height: '60px',
        objectFit: 'cover',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    creativePreviewHover: {
        transform: 'scale(1.05)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    searchWrapper: {
        position: 'relative',
        flex: '1 1 200px',
        minWidth: '180px'
    },
    searchInput: {
        width: '100%',
        padding: '8px 14px 8px 36px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '40px',
        background: 'white'
    },
    filterGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px'
    },
    // Replace the existing statsContainer with these new styles
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',

    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #edf2f7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease'
    },
    statCardLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    statCardLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    statCardValue: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#0f172a',
        marginTop: '2px',
        lineHeight: '1.2'
    },
    statCardIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        height: '38px',
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    dateFilterBtnActive: {
        borderColor: '#e66d33',
        color: '#e66d33'
    },
    rightControlsGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap',
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1', // Takes remaining space
        minWidth: '280px',
        maxWidth: "300px",
    },
};

const FoodSuperadminCampaign = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [formData, setFormData] = useState({
        campaignName: "",
        description: "",
        interests: ["JOBS"],
        goal: "BRANDING",
        medium: "APP",
        status: "ACTIVE",
        startDate: "",
        subGoal: "",
        endDate: "",
        city: "",
        radiusKm: 100,
        centerLatitude: 17.3850,
        centerLongitude: 78.4867,
        deepLink: "",
        appType: "FOOD_AND_BEVERAGES",
        mediaType: "IMAGE",
        addDisplayPosition: "ADD_SCREEN",
        customerId: "ADM161220251",
        paymentStatus: "PENDING",
        loops: 7,
        period: "PER_DAY",
        targetAudience: ["Users"],
        targeting: {
            interests: ["JOBS"],
            city: "",
            centerLatitude: 17.3850,
            centerLongitude: 78.4867,
            radiusKm: 100,
            targetAudience: ["Users"],
        }
    });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [viewCampaign, setViewCampaign] = useState(null);
    const [creativeFile, setCreativeFile] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const [loading, setLoading] = useState(true);
    const [locationLoaded, setLocationLoaded] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Digital-specific states
    const [screenIds, setScreenIds] = useState([]);
    const [screens, setScreens] = useState([]);
    const [loadingScreens, setLoadingScreens] = useState(false);
    const [creativeResolution, setCreativeResolution] = useState(null);
    const [creativeDuration, setCreativeDuration] = useState(null);
    const [creativeValidationMessages, setCreativeValidationMessages] = useState([]);
    const [updatingStatus, setUpdatingStatus] = useState({});

    // State for rejection input inside view modal
    const [showRejectionInput, setShowRejectionInput] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');

    // State for approval modal
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [selectedCampaignForApproval, setSelectedCampaignForApproval] = useState(null);
    const [approvalData, setApprovalData] = useState({
        campaignId: null,
        approvalStatus: "PENDING",
        rejectionReason: ""
    });

    // State for media preview
    const [showMediaPreview, setShowMediaPreview] = useState(false);
    const [previewMediaUrl, setPreviewMediaUrl] = useState('');
    const [previewMediaType, setPreviewMediaType] = useState('');

    // Search state
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);
    // Add this after the other useState declarations
    // Date filter states - Default "All"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        const date = new Date();
        date.setDate(1);
        return date.toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    // Stats state
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        pending: 0,
        rejected: 0,
        todayCampaigns: 0
    });
    // Refs
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);
    const circleRef = useRef(null);
    const searchInputRef = useRef(null);
    // Date filter options
    const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];
    // Interest options
    const interestOptions = [
        "JOBS", "FOOD", "EDUCATION", "OFFERS", "REAL_ESTATE",
        "ONLINE_COURSES", "BAKERY", "HEALTH", "TRAVEL", "ENTERTAINMENT"
    ];

    const goalOptions = ["BRANDING", "DISCOUNT", "LEADS", "EVENTS", "SPONSORSHIP"];
    const subGoalOptionsMap = {
        BRANDING: ["BRAND_AWARENESS", "BRAND_RECALL", "PREMIUM_POSTING"],
        LEADS: ["GET_MORE_MESSAGES", "GET_MORE_CALLS", "GET_MORE_WHATSAPP_MESSAGE", "GET_MORE_PAGE_LIKES", "GET_MORE_LEADS", "GET_MORE_WEBSITE_VISITORS"]
    };
    const subGoalOptions = subGoalOptionsMap[formData.goal] || [];
    const mediumOptions = ["APP", "DIGITAL", "PHYSICAL"];
    const statusOptions = ["DRAFT", "SCHEDULED", "ACTIVE", "PAUSED", "COMPLETED", "CANCELLED"];
    const approvalStatusOptions = ["PENDING", "APPROVED", "REJECTED"];
    const paymentStatusOptions = ["PENDING", "PAID", "FAILED", "REFUNDED", "CANCELLED"];
    const appTypeOptions = ["FOOD_AND_BEVERAGES", "RETAIL", "SERVICES", "ENTERTAINMENT", "EDUCATION", "HEALTHCARE"];
    const displayPositionOptions = ["ADD_SCREEN", "HOMEPAGE_BANNER", "PRODUCT_PAGE", "CHECKOUT_PAGE", "IN_APP_POPUP"];
    const mediaTypeOptions = ["IMAGE", "VIDEO"];

    const displayPositionRatios = {
        "ADD_SCREEN": { ratio: "9:16", resolution: "R_720P", description: "Full-screen vertical ad" },
        "HOMEPAGE_BANNER": { ratio: "16:9", resolution: "R_4K", description: "Wide banner style" },
        "PRODUCT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Product-focused layout" },
        "CHECKOUT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Compact promotional block" },
        "IN_APP_POPUP": { ratio: "9:16", resolution: "R_720P", description: "Overlay popup style" }
    };

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Fetch all campaigns
    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                showLoader();
                setLoading(true);
                const result = await getAllCampaignsAPI();
                const campaignsArray = Array.isArray(result) ? result : [result];
                setCampaigns(campaignsArray);
                setFilteredCampaigns(campaignsArray);
            } catch (error) {
                console.error("❌ Error fetching campaigns:", error);
                alert("Failed to fetch campaigns");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };
        fetchCampaigns();
    }, []);

    // Filter campaigns based on search
    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredCampaigns(campaigns);
            return;
        }
        const term = searchTerm.toLowerCase().trim();
        const filtered = campaigns.filter(campaign =>
            campaign.campaignName?.toLowerCase().includes(term) ||
            campaign.description?.toLowerCase().includes(term) ||
            campaign.campaignId?.toString().includes(term) ||
            campaign.id?.toString().includes(term)
        );
        setFilteredCampaigns(filtered);
    }, [searchTerm, campaigns]);
    // Replace your existing filter useEffect with this:
    useEffect(() => {
        let filtered = campaigns;

        // Apply date filter
        filtered = filterByDateRange(filtered);

        // Apply search filter
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase().trim();
            filtered = filtered.filter(campaign =>
                campaign.campaignName?.toLowerCase().includes(term) ||
                campaign.description?.toLowerCase().includes(term) ||
                campaign.campaignId?.toString().includes(term) ||
                campaign.id?.toString().includes(term)
            );
        }

        setFilteredCampaigns(filtered);
    }, [searchTerm, campaigns, selectedDateFilter, customFromDate, customToDate]);



    const handleStatusToggle = async (campaign) => {
        const campaignId = campaign.id || campaign.campaignId;
        const currentStatus = campaign.status || 'DRAFT';
        const newStatus = currentStatus === 'ACTIVE' ? 'PAUSED' : 'ACTIVE';

        // Set loading state for this specific campaign
        setUpdatingStatus(prev => ({ ...prev, [campaignId]: true }));

        try {
            showLoader();
            await updateCampaignStatusAPI(campaignId, newStatus);

            // Update the campaign in the list
            setCampaigns(prev => prev.map(c =>
                (c.id === campaignId || c.campaignId === campaignId)
                    ? { ...c, status: newStatus }
                    : c
            ));
            setFilteredCampaigns(prev => prev.map(c =>
                (c.id === campaignId || c.campaignId === campaignId)
                    ? { ...c, status: newStatus }
                    : c
            ));

            alert(`Campaign ${newStatus === 'ACTIVE' ? 'activated' : 'paused'} successfully!`);
        } catch (error) {
            console.error("Error updating status:", error);
            alert("Failed to update campaign status");
        } finally {
            hideLoader();
            setUpdatingStatus(prev => ({ ...prev, [campaignId]: false }));
        }
    };

    // Add this useEffect after the existing useEffect hooks to calculate stats
    useEffect(() => {
        // Calculate stats from filteredCampaigns (which already has date filter applied)
        const total = filteredCampaigns.length;
        const active = filteredCampaigns.filter(c => c.status === 'ACTIVE').length;
        const pending = filteredCampaigns.filter(c => c.approvalStatus === 'PENDING').length;
        const rejected = filteredCampaigns.filter(c => c.approvalStatus === 'REJECTED').length;

        // Today's campaigns
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const todayCampaigns = filteredCampaigns.filter(item => {
            const createdDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!createdDate) return false;
            return createdDate >= today && createdDate < tomorrow;
        }).length;

        setStats({ total, active, pending, rejected, todayCampaigns });
    }, [filteredCampaigns]);
    const getStatusColor = (status) => {
        const colors = {
            'DRAFT': '#9E9E9E',
            'SCHEDULED': '#FF9800',
            'ACTIVE': '#4CAF50',
            'PAUSED': '#FFC107',
            'COMPLETED': '#2196F3',
            'CANCELLED': '#f44336'
        };
        return colors[status] || '#9E9E9E';
    };

    const getApprovalStatusColor = (status) => {
        const colors = {
            'PENDING': '#FF9800',
            'APPROVED': '#4CAF50',
            'REJECTED': '#f44336'
        };
        return colors[status] || '#9E9E9E';
    };

    const getPaymentStatusColor = (status) => {
        const colors = {
            'PENDING': '#FF9800',
            'PAID': '#4CAF50',
            'FAILED': '#f44336',
            'REFUNDED': '#9C27B0',
            'CANCELLED': '#9E9E9E'
        };
        return colors[status] || '#9E9E9E';
    };

    const getApprovalBadge = (status) => {
        if (status === 'APPROVED') return styles.badgeApproved;
        if (status === 'REJECTED') return styles.badgeRejected;
        return styles.badgePending;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleString("en-GB", {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const openMediaPreview = (url) => {
        if (!url) return;
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];
        const extension = url.split('.').pop()?.toLowerCase().split('?')[0];
        const isVideo = videoExtensions.includes(extension) || url.includes('video') || url.includes('mp4');
        setPreviewMediaUrl(url);
        setPreviewMediaType(isVideo ? 'video' : 'image');
        setShowMediaPreview(true);
    };

    const closeMediaPreview = () => {
        setShowMediaPreview(false);
        setPreviewMediaUrl('');
        setPreviewMediaType('');
    };

    // Handle view campaign
    const handleViewCampaign = async (campaign) => {
        const campaignId = campaign.id || campaign.campaignId;
        try {
            showLoader();
            const data = await getCampaignByIdAPI(campaignId);
            setViewCampaign(data || campaign);
        } catch (error) {
            console.error("Error fetching campaign:", error);
            setViewCampaign(campaign);
        } finally {
            hideLoader();
        }
        setShowRejectionInput(false);
        setRejectionReason('');
        setShowViewModal(true);
    };

    // Handle delete campaign
    const handleDelete = async (campaignId) => {
        if (!window.confirm("Are you sure you want to delete this campaign?")) return;
        try {
            showLoader();
            await deleteCampaignAPI(campaignId);
            setCampaigns(prev => prev.filter(c => c.id !== campaignId && c.campaignId !== campaignId));
            setFilteredCampaigns(prev => prev.filter(c => c.id !== campaignId && c.campaignId !== campaignId));
            alert("Campaign deleted successfully!");
        } catch (error) {
            console.error("Error deleting campaign:", error);
            alert("Failed to delete campaign");
        } finally {
            hideLoader();
        }
    };

    // Handle approve campaign
    const handleDirectApprove = async (campaign) => {
        if (!window.confirm(`Are you sure you want to approve campaign "${campaign.campaignName}"?`)) return;
        try {
            showLoader();
            const campaignId = campaign.id || campaign.campaignId;
            await updateCampaignApprovalAPI({ campaignId, approvalStatus: "APPROVED", rejectionReason: "" });
            updateCampaignInList(campaignId, "APPROVED");
            alert("Campaign approved successfully!");
        } catch (error) {
            console.error("Error approving campaign:", error);
            alert("Failed to approve campaign");
        } finally {
            hideLoader();
        }
    };

    // Handle reject campaign
    const handleDirectReject = async (campaign) => {
        if (!rejectionReason.trim()) {
            alert("Please provide a rejection reason");
            return;
        }
        try {
            showLoader();
            const campaignId = campaign.id || campaign.campaignId;
            await updateCampaignApprovalAPI({ campaignId, approvalStatus: "REJECTED", rejectionReason: rejectionReason.trim() });
            updateCampaignInList(campaignId, "REJECTED");
            alert("Campaign rejected successfully!");
            setShowRejectionInput(false);
            setRejectionReason("");
        } catch (error) {
            console.error("Error rejecting campaign:", error);
            alert("Failed to reject campaign");
        } finally {
            hideLoader();
        }
    };

    const updateCampaignInList = (campaignId, status) => {
        setCampaigns(prev => prev.map(c =>
            (c.id === campaignId || c.campaignId === campaignId) ? { ...c, approvalStatus: status } : c
        ));
        setFilteredCampaigns(prev => prev.map(c =>
            (c.id === campaignId || c.campaignId === campaignId) ? { ...c, approvalStatus: status } : c
        ));
        if (viewCampaign && (viewCampaign.id === campaignId || viewCampaign.campaignId === campaignId)) {
            setViewCampaign(prev => ({ ...prev, approvalStatus: status }));
        }
    };

    // Calculate stats
    const totalCampaigns = campaigns.length;
    const approvedCount = campaigns.filter(c => c.approvalStatus === 'APPROVED').length;
    const pendingCount = campaigns.filter(c => c.approvalStatus === 'PENDING').length;
    const rejectedCount = campaigns.filter(c => c.approvalStatus === 'REJECTED').length;
    const activeCount = campaigns.filter(c => c.status === 'ACTIVE').length;

    // Add these functions after the existing useEffect hooks

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Get date range from selection
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const createdDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!createdDate) return false;
            return createdDate >= startDate && createdDate <= endDate;
        });
    };

    // Calculate stats
    const calculateStats = (dataArray) => {
        const total = dataArray.length;
        const active = dataArray.filter(c => c.status === 'ACTIVE').length;
        const pending = dataArray.filter(c => c.approvalStatus === 'PENDING').length;
        const rejected = dataArray.filter(c => c.approvalStatus === 'REJECTED').length;

        // Today's campaigns
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const todayCampaigns = dataArray.filter(item => {
            const createdDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!createdDate) return false;
            return createdDate >= today && createdDate < tomorrow;
        }).length;

        setStats({ total, active, pending, rejected, todayCampaigns });
    };

    const getDateFilterDisplayText = () => {
        if (selectedDateFilter === "All") return "All";
        if (selectedDateFilter === "Custom Range") {
            return `${customFromDate} to ${customToDate}`;
        }
        return selectedDateFilter;
    };

    const handleDateFilterSelect = (filter) => {
        setSelectedDateFilter(filter);
        if (filter === "Custom Range") {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setShowDateDropdown(false);
        }
    };

    const applyCustomRange = () => {
        setShowCustomPicker(false);
        setShowDateDropdown(false);
    };



    return (
        <div style={styles.container}>

            {/* Dashboard Stats Cards - Add this BEFORE the header */}
            {/* ─── Dashboard Stats Cards ────────────────────────────────────── */}
            <div style={styles.statsGrid}>
                {/* Total Campaigns */}
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Total Campaigns</span>
                        <span style={styles.statCardValue}>{stats.total}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#eef2ff' }}>
                        <Icons.Users />
                    </div>
                </div>

                {/* Active Campaigns */}
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Active</span>
                        <span style={{ ...styles.statCardValue, color: '#16a34a' }}>{stats.active}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                        <Icons.CheckCircle />
                    </div>
                </div>

                {/* Pending Approval */}
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Pending Approval</span>
                        <span style={{ ...styles.statCardValue, color: '#f59e0b' }}>{stats.pending}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fef3c7' }}>
                        <Icons.Clock />
                    </div>
                </div>

                {/* Rejected Campaigns */}
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Rejected</span>
                        <span style={{ ...styles.statCardValue, color: '#dc2626' }}>{stats.rejected}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fee2e2' }}>
                        <Icons.XCircle />
                    </div>
                </div>

                {/* Today's Campaigns */}
                <div style={{ ...styles.statCard, borderColor: '#e66d33', borderWidth: '2px' }}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Today's Campaigns</span>
                        <span style={{ ...styles.statCardValue, color: '#e66d33' }}>{stats.todayCampaigns}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fef3e8' }}>
                        <Icons.Today />
                    </div>
                </div>
            </div>
            {/* Media Preview Modal */}
            {showMediaPreview && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                    padding: '20px'
                }} onClick={closeMediaPreview}>
                    <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }} onClick={e => e.stopPropagation()}>
                        <button
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '-40px',
                                background: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                fontSize: '20px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10001
                            }}
                            onClick={closeMediaPreview}
                        >
                            ✕
                        </button>
                        {previewMediaType === 'video' ? (
                            <video controls autoPlay style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }}>
                                <source src={previewMediaUrl} type="video/mp4" />
                                <source src={previewMediaUrl} type="video/webm" />
                                <source src={previewMediaUrl} type="video/ogg" />
                            </video>
                        ) : (
                            <img src={previewMediaUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }} />
                        )}
                    </div>
                </div>
            )}


            {/* Search Filter */}
            {/* Search & Filters */}
            <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0px" }}>
                {/* LEFT SIDE - Search */}
                <div style={styles.searchGroup}>
                    <div style={styles.searchWrapper}>
                        <input
                            type="text"
                            placeholder="Search campaigns..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                ...styles.searchInput,
                                borderColor: searchTerm ? "#e66d33" : "#e2e8f0",
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = "#e66d33";
                                e.target.style.boxShadow = "0 0 0 3px rgba(230,109,51,0.1)";
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                            }}
                        />
                    </div>
                </div>

                {/* RIGHT SIDE - All controls */}
                <div style={styles.rightControlsGroup}>
                    {/* Date Filter */}
                    <div ref={dateDropdownRef} style={{ position: "relative" }}>
                        <button
                            onClick={() => setShowDateDropdown(!showDateDropdown)}
                            style={{
                                ...styles.dateFilterBtn,
                                ...(showDateDropdown ? styles.dateFilterBtnActive : {})
                            }}
                        >
                            <Calendar size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                            <span>{getDateFilterDisplayText()}</span>
                            <ChevronDown size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                        </button>

                        {showDateDropdown && !showCustomPicker && (
                            <div style={{
                                position: "absolute",
                                top: "45px",
                                right: 0,
                                background: "white",
                                border: "1px solid #e2e8f0",
                                borderRadius: "12px",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                zIndex: 1000,
                                minWidth: "180px",
                                overflow: "hidden"
                            }}>
                                {dateFilterOptions.map(option => (
                                    <div
                                        key={option}
                                        onClick={() => handleDateFilterSelect(option)}
                                        style={{
                                            padding: "10px 16px",
                                            fontSize: "13px",
                                            cursor: "pointer",
                                            background: selectedDateFilter === option ? "#fef3e8" : "white",
                                            color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                            borderBottom: "1px solid #f0f0f0"
                                        }}
                                    >
                                        {option}
                                    </div>
                                ))}
                            </div>
                        )}

                        {showCustomPicker && (
                            <div style={{
                                position: "absolute",
                                top: "45px",
                                right: 0,
                                background: "white",
                                border: "1px solid #e2e8f0",
                                borderRadius: "12px",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                zIndex: 1000,
                                width: "280px",
                                padding: "16px"
                            }}>
                                <div style={{ marginBottom: "12px" }}>
                                    <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                    <input
                                        type="date"
                                        value={customFromDate}
                                        onChange={(e) => setCustomFromDate(e.target.value)}
                                        style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                        max={customToDate}
                                    />
                                </div>
                                <div style={{ marginBottom: "16px" }}>
                                    <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                    <input
                                        type="date"
                                        value={customToDate}
                                        onChange={(e) => setCustomToDate(e.target.value)}
                                        style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                        min={customFromDate}
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                                <button
                                    onClick={applyCustomRange}
                                    style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                                >
                                    Apply Range
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Clear Filters Button */}
                    <button
                        onClick={() => {
                            setSearchTerm("");
                            setSelectedDateFilter("All");
                            setCustomFromDate(() => {
                                const date = new Date();
                                date.setDate(1);
                                return date.toISOString().split('T')[0];
                            });
                            setCustomToDate(new Date().toISOString().split('T')[0]);
                        }}
                        style={{ ...styles.button, ...styles.buttonSecondary }}
                    >
                        Clear Filters
                    </button>

                    {/* Create Campaign Button */}
                    {/* <button
                        onClick={() => {
                            setFormData({
                                campaignName: "",
                                description: "",
                                interests: ["JOBS"],
                                goal: "BRANDING",
                                medium: "APP",
                                status: "ACTIVE",
                                startDate: "",
                                subGoal: "",
                                endDate: "",
                                city: "",
                                radiusKm: 100,
                                centerLatitude: 17.3850,
                                centerLongitude: 78.4867,
                                deepLink: "",
                                appType: "FOOD_AND_BEVERAGES",
                                mediaType: "IMAGE",
                                addDisplayPosition: "ADD_SCREEN",
                                customerId: "ADM161220251",
                                paymentStatus: "PENDING",
                                loops: 7,
                                period: "PER_DAY",
                                targetAudience: ["Users"],
                                targeting: {
                                    interests: ["JOBS"],
                                    city: "",
                                    centerLatitude: 17.3850,
                                    centerLongitude: 78.4867,
                                    radiusKm: 100,
                                    targetAudience: ["Users"],
                                },
                            });
                            setCreativeFile(null);
                            setScreenIds([]);
                            setShowAddModal(true);
                        }}
                        style={{ ...styles.button, ...styles.buttonSuccess }}
                    >
                        <Icons.Add /> Create Campaign
                    </button> */}
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '3%' }}>#</th>
                            <th style={{ ...styles.th, width: '8%' }}>Campaign Name</th>
                            <th style={{ ...styles.th, width: '8%' }}>Description</th>
                            <th style={{ ...styles.th, width: '7%' }}>Interests</th>
                            <th style={{ ...styles.th, width: '6%' }}>Goal</th>
                            <th style={{ ...styles.th, width: '6%' }}>Medium</th>
                            <th style={{ ...styles.th, width: '5%' }}>Loops</th>
                            <th style={{ ...styles.th, width: '5%' }}>Days</th>
                            <th style={{ ...styles.th, width: '5%', textAlign: 'center' }}>Active/Inactive</th>
                            <th style={{ ...styles.th, width: '5%', textAlign: 'center' }}>Status</th>
                            <th style={{ ...styles.th, width: '5%', textAlign: 'center' }}>Approval</th>
                            <th style={{ ...styles.th, width: '5%', textAlign: 'center' }}>Payment</th>
                            <th style={{ ...styles.th, width: '5%' }}>Start Date</th>
                            <th style={{ ...styles.th, width: '5%' }}>End Date</th>
                            <th style={{ ...styles.th, width: '5%' }}>City</th>
                            <th style={{ ...styles.th, width: '4%' }}>Radius</th>
                            <th style={{ ...styles.th, width: '5%' }}>App Type</th>
                            <th style={{ ...styles.th, width: '5%' }}>Media</th>
                            <th style={{ ...styles.th, width: '7%' }}>Display</th>
                            <th style={{ ...styles.th, width: '6%' }}>Creative</th>
                            <th style={{ ...styles.th, width: '6%', textAlign: 'center' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="18" style={{ padding: 0 }}>
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading campaigns...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : filteredCampaigns.length === 0 ? (
                            <tr>
                                <td colSpan="18" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No campaigns found</div>
                                        <div style={styles.emptyStateSubtext}>
                                            {searchTerm ? 'Try adjusting your search terms' : 'Create your first campaign to get started'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredCampaigns.map((campaign, index) => (
                                <tr
                                    key={campaign.id || campaign.campaignId || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>{campaign.campaignName || "-"}</td>
                                    <td style={{ ...styles.td }}>{campaign.description || "-"}</td>
                                    <td style={styles.td}>
                                        <span style={{
                                            fontSize: '10px',
                                            background: '#edf2f7',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            color: '#4a5568',
                                            display: 'inline-block'
                                        }}>
                                            {campaign.interests && campaign.interests.length > 0
                                                ? campaign.interests.join(', ')
                                                : campaign.targeting?.interests?.join(', ') || "-"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, fontSize: '12px' }}>{campaign.goal || "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '12px' }}>
                                        <span style={{
                                            background: campaign.medium === 'DIGITAL' ? '#bee3f8' :
                                                campaign.medium === 'APP' ? '#c6f6d5' : '#fefcbf',
                                            padding: '2px 10px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            color: campaign.medium === 'DIGITAL' ? '#2a4365' :
                                                campaign.medium === 'APP' ? '#276749' : '#975a16'
                                        }}>
                                            {campaign.medium || "-"}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            background: '#e8f0fe',
                                            padding: '2px 10px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#1a73e8'
                                        }}>
                                            {campaign.loops || 7}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            background: '#e8f0fe',
                                            padding: '2px 10px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#f730f4'
                                        }}>
                                            {campaign.loops || 1}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {updatingStatus[campaign.id || campaign.campaignId] ? (
                                            <span style={{
                                                fontSize: '12px',
                                                color: '#718096',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '6px'
                                            }}>
                                                <span className="spinner-border spinner-border-sm" role="status" />
                                                Updating...
                                            </span>
                                        ) : (
                                            <button
                                                onClick={() => handleStatusToggle(campaign)}
                                                style={{
                                                    ...styles.button,
                                                    background: campaign.status === 'ACTIVE' ? '#fee2e2' : '#dcfce7',
                                                    color: campaign.status === 'ACTIVE' ? '#dc2626' : '#16a34a',
                                                    border: `2px solid ${campaign.status === 'ACTIVE' ? '#dc2626' : '#16a34a'}`,
                                                    borderRadius: '8px',
                                                    padding: '6px 16px',
                                                    height: '36px',
                                                    width: '90px',
                                                    justifyContent: 'center',
                                                    gap: '6px',
                                                    fontWeight: '600',
                                                    fontSize: '13px',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer',
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                                title={campaign.status === 'ACTIVE' ? 'Pause campaign' : 'Activate campaign'}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.05)';
                                                    e.currentTarget.style.boxShadow = `0 4px 12px ${campaign.status === 'ACTIVE' ? 'rgba(220,38,38,0.3)' : 'rgba(22,163,74,0.3)'}`;
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}
                                            >
                                                {campaign.status === 'ACTIVE' ? (
                                                    <><FaPause size={14} /> Pause</>
                                                ) : (
                                                    <><FaPlay size={14} /> Play</>
                                                )}
                                            </button>
                                        )}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.badge,
                                            backgroundColor: getStatusColor(campaign.status),
                                            color: 'white'
                                        }}>
                                            {campaign.status || "DRAFT"}
                                        </span>
                                    </td>

                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{ ...styles.badge, ...getApprovalBadge(campaign.approvalStatus || 'PENDING') }}>
                                            {campaign.approvalStatus || 'PENDING'}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.badge,
                                            backgroundColor: getPaymentStatusColor(campaign.paymentStatus || 'PENDING'),
                                            color: 'white'
                                        }}>
                                            {campaign.paymentStatus || 'PENDING'}
                                        </span>
                                    </td>
                                    <td style={styles.td}>{formatDate(campaign.startDate)}</td>
                                    <td style={styles.td}>{formatDate(campaign.endDate)}</td>
                                    <td style={styles.td}>{campaign.city || campaign.targeting?.city || "-"}</td>
                                    <td style={styles.td}>{campaign.radiusKm || campaign.targeting?.radiusKm ? `${campaign.radiusKm || campaign.targeting?.radiusKm} km` : "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>{campaign.appType || "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>
                                        <span style={{
                                            background: campaign.mediaType === 'VIDEO' ? '#fed7d7' : '#c6f6d5',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            fontSize: '10px',
                                            fontWeight: '600',
                                            color: campaign.mediaType === 'VIDEO' ? '#9b2c2c' : '#276749'
                                        }}>
                                            {campaign.mediaType || "-"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>
                                        {campaign.addDisplayPosition ? campaign.addDisplayPosition.replace(/_/g, ' ') : "-"}
                                    </td>
                                    <td style={styles.td}>
                                        {campaign.imageUrl ? (
                                            <button
                                                onClick={() => openMediaPreview(campaign.imageUrl)}
                                                style={{
                                                    ...styles.button,
                                                    ...styles.buttonInfo,
                                                    padding: '4px 10px',
                                                    height: '28px',
                                                    fontSize: '11px'
                                                }}
                                            >
                                                <Icons.Image /> View
                                            </button>
                                        ) : "-"}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <div style={styles.actionGroup}>
                                            <button
                                                onClick={() => handleViewCampaign(campaign)}
                                                style={{ ...styles.button, ...styles.buttonInfo }}
                                            >
                                                <Icons.View /> View
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setSelectedCampaign(campaign);
                                                    setShowEditModal(true);
                                                }}
                                                style={{ ...styles.button, ...styles.buttonPrimary }}
                                            >
                                                <Icons.Edit /> Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete(campaign.id || campaign.campaignId)}
                                                style={{ ...styles.button, ...styles.buttonDanger }}
                                            >
                                                <Icons.Delete /> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* View Modal */}
            {showViewModal && viewCampaign && (
                <div style={styles.modalOverlay} onClick={() => setShowViewModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.View style={{ color: '#e66d33' }} /> Campaign Details
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowViewModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            {/* Basic Info */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Basic Information</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>ID:</strong> <span>{viewCampaign.id || viewCampaign.campaignId}</span>
                                    <strong>Campaign Name:</strong> <span>{viewCampaign.campaignName}</span>
                                    <strong>Description:</strong> <span>{viewCampaign.description}</span>
                                    <strong>Goal:</strong> <span>{viewCampaign.goal}</span>
                                    <strong>Medium:</strong> <span>{viewCampaign.medium}</span>
                                    <strong>Status:</strong>
                                    <span style={{ ...styles.badge, backgroundColor: getStatusColor(viewCampaign.status), color: 'white' }}>
                                        {viewCampaign.status}
                                    </span>
                                    <strong>Approval Status:</strong>
                                    <span style={{ ...styles.badge, ...getApprovalBadge(viewCampaign.approvalStatus || 'PENDING') }}>
                                        {viewCampaign.approvalStatus || 'PENDING'}
                                    </span>
                                    <strong>Payment Status:</strong>
                                    <span style={{ ...styles.badge, backgroundColor: getPaymentStatusColor(viewCampaign.paymentStatus || 'PENDING'), color: 'white' }}>
                                        {viewCampaign.paymentStatus || 'PENDING'}
                                    </span>
                                </div>
                            </div>

                            {/* Dates */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Dates</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>Start Date:</strong> <span>{formatDateTime(viewCampaign.startDate)}</span>
                                    <strong>End Date:</strong> <span>{formatDateTime(viewCampaign.endDate)}</span>
                                    <strong>Created At:</strong> <span>{formatDateTime(viewCampaign.createdAt)}</span>
                                </div>
                            </div>

                            {/* Targeting */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Targeting</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>Interests:</strong>
                                    <span>
                                        {viewCampaign.targeting?.interests?.join(', ') ||
                                            viewCampaign.interests?.join(', ') || 'None'}
                                    </span>
                                    <strong>City:</strong> <span>{viewCampaign.city || viewCampaign.targeting?.city || 'Not specified'}</span>
                                    <strong>Radius:</strong> <span>{viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm ? `${viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm} km` : 'Not specified'}</span>
                                </div>
                            </div>

                            {/* Creative */}
                            {viewCampaign.imageUrl && (
                                <div style={{ marginBottom: '16px' }}>
                                    <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Creative</h4>
                                    <button
                                        onClick={() => openMediaPreview(viewCampaign.imageUrl)}
                                        style={{ ...styles.button, ...styles.buttonSuccess }}
                                    >
                                        <Icons.Image /> View Creative
                                    </button>
                                </div>
                            )}

                            {/* Approval Actions */}
                            <div style={{
                                padding: '16px',
                                background: '#f7fafc',
                                borderRadius: '8px',
                                border: '1px solid #edf2f7'
                            }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '14px' }}>Approval Actions</h4>
                                {showRejectionInput ? (
                                    <div>
                                        <label style={styles.label}>Rejection Reason *</label>
                                        <textarea
                                            placeholder="Please provide reason for rejection"
                                            value={rejectionReason}
                                            onChange={(e) => setRejectionReason(e.target.value)}
                                            rows="3"
                                            style={styles.textarea}
                                        />
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px', justifyContent: 'flex-end' }}>
                                            <button
                                                onClick={() => {
                                                    setShowRejectionInput(false);
                                                    setRejectionReason('');
                                                }}
                                                style={{ ...styles.button, ...styles.buttonSecondary }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => handleDirectReject(viewCampaign)}
                                                style={{ ...styles.button, ...styles.buttonDanger }}
                                            >
                                                Submit Rejection
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                        <button
                                            onClick={() => handleDirectApprove(viewCampaign)}
                                            disabled={viewCampaign.approvalStatus === 'APPROVED'}
                                            style={{
                                                ...styles.button,
                                                ...styles.buttonSuccess,
                                                opacity: viewCampaign.approvalStatus === 'APPROVED' ? 0.5 : 1,
                                                cursor: viewCampaign.approvalStatus === 'APPROVED' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <Icons.Approve /> {viewCampaign.approvalStatus === 'APPROVED' ? 'Already Approved' : 'Approve'}
                                        </button>
                                        <button
                                            onClick={() => setShowRejectionInput(true)}
                                            disabled={viewCampaign.approvalStatus === 'REJECTED'}
                                            style={{
                                                ...styles.button,
                                                ...styles.buttonDanger,
                                                opacity: viewCampaign.approvalStatus === 'REJECTED' ? 0.5 : 1,
                                                cursor: viewCampaign.approvalStatus === 'REJECTED' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <Icons.Reject /> {viewCampaign.approvalStatus === 'REJECTED' ? 'Already Rejected' : 'Reject'}
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div style={styles.modalFooter}>
                                <button
                                    onClick={() => setShowViewModal(false)}
                                    style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Modal - Simplified for brevity, same as original but with premium styling */}
            {showAddModal && (
                <div style={styles.modalOverlay} onClick={() => setShowAddModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.Add style={{ color: '#e66d33' }} /> Create Campaign
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowAddModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Campaign Name *</label>
                                    <input
                                        type="text"
                                        name="campaignName"
                                        placeholder="Enter campaign name"
                                        value={formData.campaignName}
                                        onChange={(e) => setFormData({ ...formData, campaignName: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Goal *</label>
                                    <select
                                        name="goal"
                                        value={formData.goal}
                                        onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {goalOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Medium *</label>
                                    <select
                                        name="medium"
                                        value={formData.medium}
                                        onChange={(e) => setFormData({ ...formData, medium: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {mediumOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Start Date *</label>
                                    <input
                                        type="date"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>End Date *</label>
                                    <input
                                        type="date"
                                        name="endDate"
                                        value={formData.endDate}
                                        onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Description</label>
                                    <textarea
                                        name="description"
                                        placeholder="Enter campaign description"
                                        value={formData.description}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                        rows="3"
                                        style={styles.textarea}
                                    />
                                </div>

                                <div style={styles.modalFooter}>
                                    <button
                                        type="button"
                                        onClick={() => setShowAddModal(false)}
                                        style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={{ ...styles.button, ...styles.buttonPrimary, flex: 1 }}
                                    >
                                        Create Campaign
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal - Simplified for brevity */}
            {showEditModal && selectedCampaign && (
                <div style={styles.modalOverlay} onClick={() => setShowEditModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.Edit style={{ color: '#e66d33' }} /> Edit Campaign
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowEditModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Campaign Name *</label>
                                    <input
                                        type="text"
                                        name="campaignName"
                                        placeholder="Enter campaign name"
                                        value={formData.campaignName}
                                        onChange={(e) => setFormData({ ...formData, campaignName: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Goal *</label>
                                    <select
                                        name="goal"
                                        value={formData.goal}
                                        onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {goalOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Medium *</label>
                                    <select
                                        name="medium"
                                        value={formData.medium}
                                        onChange={(e) => setFormData({ ...formData, medium: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {mediumOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Status *</label>
                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {statusOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.modalFooter}>
                                    <button
                                        type="button"
                                        onClick={() => setShowEditModal(false)}
                                        style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={{ ...styles.button, ...styles.buttonPrimary, flex: 1 }}
                                    >
                                        Update Campaign
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @media (max-width: 768px) {
                    .stats-container {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .table-container table {
                        font-size: 12px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    .modal {
                        padding: 16px !important;
                        width: 98% !important;
                    }
                }

                @media (max-width: 480px) {
                    .stats-container {
                        grid-template-columns: 1fr !important;
                    }
                    .stat-value {
                        font-size: 18px !important;
                    }
                    .table-container table {
                        font-size: 10px !important;
                        min-width: 1200px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                    .button {
                        font-size: 10px !important;
                        padding: 4px 8px !important;
                        height: 26px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
                    filtersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 0 12px 0',
    borderBottom: '1px solid #edf2f7',
    marginBottom: '12px'
},
searchGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: '1 1 auto',
    minWidth: '280px'
},
searchWrapper: {
    position: 'relative',
    flex: '1 1 200px',
    minWidth: '180px'
},
searchInput: {
    flex: '1',
    padding: '8px 14px 8px 36px',
    border: '2px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '13px',
    outline: 'none',
    transition: 'all 0.3s ease',
    height: '40px',
    background: 'white'
},
            `}</style>
        </div>
    );
};

export default FoodSuperadminCampaign;